export const SUPPORT_PATH = '/support';
export const LOGIN_PATH = '/login';
export const PASSWORD_RESET_PATH = '/password-reset';
export const ORDERS_PATH = '/orders';
export const CREATE_ORDER_PATH = ORDERS_PATH + '/add';
export const ORDER_PATH = '/order';
export const PURCHASE_ORDERS_PATH = '/purchase-orders';
export const CURRENT_ACCOUNTS_PATH = '/current-accounts';
export const VIEW_CURRENT_ACCOUNT_PATH = CURRENT_ACCOUNTS_PATH + '/:id';
export const VIEW_ORDER_PATH = ORDER_PATH + '/:id';
export const USERS_PATH = '/users';
export const BACKOFFICE_USERS_PATH = '/internal-users';
export const ASSIGN_PERMISSIONS_PATH = '/internal-user/:id';
export const CREATE_USER_PATH = '/user/create';
export const CREATE_BACKOFFICE_USER_PATH = '/user/backoffice/create';
export const ASSIGN_ROLES_USER_PATH = '/user/:id';
export const USER_PATH = '/user';
export const BACKOFFICE_USER_PATH = '/internal-user';
export const AUTHORIZATIONS_PATH = '/authorizations';
export const AUTHORIZATION_PATH = '/authorization';
export const VIEW_AUTHORIZATION_PATH = AUTHORIZATION_PATH + '/:id'
export const CUSTOMER_ONBOARDINGS_PATH = '/customer-onboardings';
export const CREATE_CUSTOMER_ONBOARDING_PATH = '/customer_onboarding/create';
export const CUSTOMER_ONBOARDING_EDITION_PATH = '/customer-onboardings/:taxpayerIdentificationNumber/edit';
export const ORDER_LOG_PATH = ORDER_PATH + '/log/:id'
export const DASHBOARD_PATH = '/dashboard';
export const ALLOWANCES_PATH = '/allowances';
export const CREATE_ALLOWANCE_PATH = ALLOWANCES_PATH + '/add';
export const CUSTOMERS_PATH = '/customers'
export const CUSTOMER_PATH = '/customer/:id'
export const DELIVERY_SITE_ONBOARDING_CREATE_PATH = '/customer/:id/delivery-site-onboarding/create'
export const DELIVERY_SITE_ONBOARDING_EDIT_PATH = '/delivery-site-onboarding/:id/edit'
export const DELIVERY_SITE_PATH = '/customer/:customerId/delivery-site/:deliverySiteCode'
export const BUDGET_PATH = '/budget';
export const LOGISTICA_PATH = '/logistica';
export const SOLD_BOXES_BY_CUSTOMER_AND_ARTICLE_PATH = '/sold-boxes-by-customer-and-article';
export const MARKETPLACE_DEMO_PATH = '/demo-tienda';
export const CREATE_LEAD_PATH = '/leads/create';
export const LEAD_ASSIGNMENT_QUEUE_PATH = '/leads/assignment-queue';
export const LEAD_PIPELINE_PATH = '/leads/pipeline';
